module.exports = __webpack_public_path__ + "assets/modal-frags-light-f8b22ce2.png";